<template>
  <div id="app">
    <div class="login-header">
      <img src="./resource/logo2.png" height="60px">
      <!--      <div>-->
      <!--        <button @click="download">CSV 다운로드</button>-->
      <!--      </div>-->
    </div>
    <div class="center">
      <SignIn/>
    </div>
    <div class="footer">
      <div class="links">
        <!-- <span>Feature 1 | </span>
        <span>Feature 2 | </span>
        <span>Feature 3 </span> -->
      </div>
      <div class="version">Version 1.06.09</div>
    </div>
  </div>
</template>

<script>
import SignIn from "@/views/components/JoinForm.vue";


export default {

  name: 'download',

  created() {
    var agent = window.navigator.userAgent.toLowerCase();
    var appName = window.navigator.appName.toLowerCase();

    if((appName === 'netscape' && agent.indexOf('trident')!== -1) || agent.indexOf('msie') !== -1)
    {
      if(confirm("현재 페이지는 인터넷익스플로러(IE)브라우저를 지원하지 않습니다. " + "크롬 혹은 엣지브라우저에서 정상적으로 작동됩니다. 해당 브라우저로 이동하시겠습니까?"))
      { window.location = "microsoft-edge:" + window.location.href; }
    }
  },

  components: {
    SignIn
  },
  data() {
    return {
    }
  },

  methods: {
    download() {
      try {
        let element = document.createElement('a');
        element.setAttribute('href','/download');
        element.click();
      } catch(error) {
        console.log(error)
      }
    }
  },
};
</script>


<style>


</style>